import { render, staticRenderFns } from "./EventPeriod.vue?vue&type=template&id=c378d0ec"
import script from "./EventPeriod.vue?vue&type=script&lang=ts"
export * from "./EventPeriod.vue?vue&type=script&lang=ts"
import style0 from "./EventPeriod.vue?vue&type=style&index=0&id=c378d0ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports